import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IVariablesClient, VariablesClient } from "app/ApiClient";
import { LoadingState } from "types";
import { initialAssignersState } from "./assignersState";

const variablesClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);

export const getAssigners = createAsyncThunk(
  "assigners/getAssigners",
  async ({ projectId, versionId, modificationId }: { projectId: number; versionId: string; modificationId?: number }) => {
    const result = await variablesClient.getAssigners(projectId, versionId, modificationId);
    return result;
  },
);

const assignersSlice = createSlice({
  name: "assigners",
  initialState: initialAssignersState,
  reducers: {
    resetAssigners: () => initialAssignersState,
  },
  extraReducers: (builder) => {
    // getAssigners
    builder.addCase(getAssigners.pending, (state) => {
      state.data = null;
      state.loading = LoadingState.pending;
    });
    builder.addCase(getAssigners.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getAssigners.rejected, (state) => {
      state.data = null;
      state.loading = LoadingState.failed;
    });
  },
});
export const { resetAssigners } = assignersSlice.actions;
export default assignersSlice.reducer;
